<template>
<div :class="$style.action">
    <icon-button
        icon="ic_menu"
        :class="$style.mobile_action"
        @click.native="SET_SIDEBAR_OPEN(!isSidebarOpen)" />
    <div :class="$style.pc_action">
        <profile v-if="isLoggedIn" />
        <a
            v-else
            :class="$style.login"
            :href="login"
            @click="$nc($event, 'gnb.login')">{{ $t("login") }}</a>
    </div>
</div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Profile from "./Profile.vue";
import { getLoginURL } from "@/data/links";
import IconButton from "@/components/mdc/IconButton.vue";

export default {
    components: { Profile, IconButton },
    data: () => ({ login: getLoginURL() }),
    computed: {
        ...mapGetters(["isLoggedIn", "isSidebarOpen"])
    },
    methods: {
        ...mapMutations(["SET_SIDEBAR_OPEN"])
    }
};
</script>

<style lang="scss" module>
@use "@/assets/scss/mixins" as m;
@use "@material/typography/typography";
@use "@material/icon-button";

.action {
    margin-left: auto;
    .mobile_action {
        display: none;
        border-radius: 3px;
        svg {
            width: 16px;
            height: 14px;
        }
        @include m.lg {
            display: inline-block;
        }
    }
    .pc_action {
        @include m.lg {
            display: none;
        }
        .login {
            padding: 10px 20px;
            font-size: typography.px-to-rem(14px);
            border-radius: 3px;
            border: solid 1px rgb(255 255 255 / 15%);
            color: white;
            background: none;
        }
    }
    :global {
        .mdc-icon-button {
            @include icon-button.density(-5);
        }
        .mdc-icon-button__ripple {
            &::before,
            &::after {
                border-radius: 4px;
            }
        }
    }
}
</style>
